import { ADULTS, CABIN_CLASS, CHILDREN, DATE_RANGE, QUALIFIERS, SEARCH, START_DATE } from 'contexts/CruiseSearchContext/constants';
import getQueryFilter from 'lib/utilities/getQueryFilter';

const getProductViewLink = (productViewLink = '', query = {}, qualifiersApplied = [], brand = {}, promotions = {}, ship = {}) => {
	const filterOptions = [START_DATE, ADULTS, CHILDREN, CABIN_CLASS, DATE_RANGE];
	console.log('getProductViewLink promotions', promotions, promotions?.queryCriteria);
	const searchFilters = filterOptions.reduce((filters, option) => {
		const filter = getQueryFilter(query, SEARCH, option);
		if (filter?.fullFilter) {
			filters.push(filter.fullFilter);
		}
		return filters;
	}, []);

	let url = `/${productViewLink}`;

	if (searchFilters.length) {
		let formatedFilters = searchFilters.join('|');
		url = `${url}&${SEARCH}=${formatedFilters}`;
	}

	if (promotions?.queryCriteria) {
		let urlPromoParameters = promotions?.queryCriteria;
		promotions?.queryCriteria.split('||').forEach((item) => {
			if (item.indexOf(ship.code) >= 0) {
				urlPromoParameters = item;
			}
		});
		url = `${url}&${SEARCH}=${urlPromoParameters}`;
	}

	const qualifiers = qualifiersApplied.join('|');

	if (qualifiers.length) {
		url = `${url}&${QUALIFIERS}=${qualifiers}`;
	}

	url = url.replace(/\/\//g, '/');

	return url;
};

export default getProductViewLink;
